// Extended-warranty add-on helpers (cart drawer + PDP disclosure).
// The warranty is a one-time Shopify product (handle below) added as a
// hidden cart line with attribute `warranty_of` = parent cart line id.
import { API_BASE } from "./apiBase";

export const WARRANTY_PRODUCT_HANDLE = "extended-warranty-6-months";
export const WARRANTY_PRICE_LABEL = "₹1,000";

// Warranty applies to ELECTRONIC products only (policy 2026-10-06):
// audio, keyboards, mice, pcb modules. Keycaps, switches and mousepads are
// returns-only — never show warranty UI for them.
const ELIGIBLE_TYPES = new Set([
  "mouse", "mice", "keyboard", "keyboards",
  "audio", "pcb module", "pcb modules",
]);

const RETURNS_ONLY_TYPES = new Set([
  "keycap", "keycaps", "switch", "switches", "mousepad", "mousepads",
]);

export function isWarrantyEligible(productType) {
  const t = String(productType || "").trim().toLowerCase();
  return ELIGIBLE_TYPES.has(t);
}

export function isReturnsOnly(productType) {
  const t = String(productType || "").trim().toLowerCase();
  return RETURNS_ONLY_TYPES.has(t);
}

export function isWarrantyLine(line) {
  return Boolean(warrantyOf(line));
}

export function warrantyOf(line) {
  const attrs = line?.attributes || [];
  const hit = attrs.find((a) => a && a.key === "warranty_of" && a.value);
  return hit ? hit.value : null;
}

export function warrantyLineFor(parentLineId, lines) {
  return (lines || []).find((l) => warrantyOf(l) === parentLineId) || null;
}

// Resolve the warranty product's variant id via Storefront. Module-cached;
// returns null while the product is draft/unpublished (button stays hidden).
let _warrantyVariantCache = undefined;
export async function fetchWarrantyVariantId() {
  if (_warrantyVariantCache !== undefined) return _warrantyVariantCache;
  try {
    const r = await fetch(`${API_BASE}/api/shopify/product/${WARRANTY_PRODUCT_HANDLE}`, { credentials: "include" });
    if (!r.ok) {
      _warrantyVariantCache = null;
      return null;
    }
    const p = await r.json();
    const v = p?.firstVariant?.id || p?.variants?.edges?.[0]?.node?.id || null;
    _warrantyVariantCache = p?.availableForSale === false ? null : v;
    return _warrantyVariantCache;
  } catch {
    return null; // don't cache network errors — retry next mount
  }
}
